import * as Position from './js/Position.js';
import * as Colour from './js/Colour.js';

(function(Drupal, $, once) {
  Drupal.behaviors.nav = {
    attach: function attach(context) {
      const nav = once(
        'nav',
        '[data-component-id="nuplayer:nav"]',
        context,
      );
      if (nav.length > 0) {
        // Responsive mobile breakpoint
        const breakpoint = 720;

        // Setup $nav and $navIcons
        const $nav = $('[data-component-id="nuplayer:nav"]');
        const iconSelectors = [
          '[data-component-id="nuplayer:bfi_player_logo"]',
          '.button [data-component-id="nuplayer:search_icon"]',
          '.button [data-component-id="nuplayer:mobile_menu_icon"]',
          '.button [data-component-id="nuplayer:close_icon"]',
        ];
        const $navIcons = $nav.find(iconSelectors.join(', '));
        const $window = $(window);

        let mobile = $window.innerWidth() < breakpoint;

        // Setup offset
        const offset = {
          parent: 0,
          page: 0,
        }

        const position = Position.create({$window, $nav, offset});
        const colour = Colour.create({$nav, $navIcons});

        const $fullWidthPage = $('[data-component-id="nuplayer:full_width_page"]');
        function updateOffset() {
          offset.parent = $nav.parent().position().top;
          offset.page = $fullWidthPage.offset().top;
        }
        updateOffset();
        $window.on('navOffset:update', updateOffset);


        // Key tabbing handler
        $nav.find('a').on('focus', function(){
          $(this).addClass('focused');
        });

        // Delays class removal to ensure menu stays open for next focus
        $nav.find('a').on('blur', function(){
          const $this = $(this);
          setTimeout(function(){
            $this.removeClass('focused');
          }, 50);
        });

        // Ensures you can click buttons to toggle view state
        $nav.find('button').on('click', function(event) {
          $(this).parent().trigger('click');
        });

        // Ensures you can toggle mobile menu when using keyboard controls
        $nav.find('.button').on('keydown', function(event) {
          // Space is pressed
          if (event.which === 32) {
            $(this).trigger('click');
            event.preventDefault();
          }
        });
        const mobileMenuState = once(
          'mobile-menu-state',
          '[data-component-id="nuplayer:nav"] #mobile-menu-state',
          context,
        );
        if (mobileMenuState.length > 0) {
          const $mobileMenuState = $(mobileMenuState);
          let mobileMenuIsOpen = $mobileMenuState[0].checked;

          $window.on('scroll', function() {
            const currentPosition = position.update({offset});
            colour.update({offset, mobileMenuIsOpen, ...currentPosition});
          });

          // Resize handler
          $window.on('resize', function () {
            // Ensures color change occurs on mobile breakpoint
            const prev = mobile;
            mobile = $window.innerWidth() < breakpoint;
            if (prev && !mobile) {
              $mobileMenuState.prop( "checked", false );
              mobileMenuIsOpen = false;
              // changeColor(clamp({value: $window.scrollTop(), min: 0}));
            }
            // Keeps nav aligned to parent when it moves up or down when page is resized
            updateOffset();
            const currentPosition = position.update({offset});
            colour.update({offset, mobileMenuIsOpen, ...currentPosition});
          });
  
          // Click handler
          $mobileMenuState.on('change', function() {
            if (this.checked) {
              // Ensures open mobile menu is dark
              mobileMenuIsOpen = true;
              position.fix(offset.page);
              colour.remove();
            } else {
              // Resets menu colour when mobile menu is closed
              mobileMenuIsOpen = false;
              const currentPosition = position.update({offset});
              colour.update({offset, mobileMenuIsOpen, ...currentPosition});
            }
          });
        }

        const queryString = new URLSearchParams(window.location.search);
        const destination = queryString.get('destination');

        if (destination !== null) {
          let alias = '';

          if (/^\/?rent\//i.test(destination)) {
            alias = '/rentals'
          } else if (/^\/?subscribe(\/|$)/i.test(destination)) {
            alias = '/subscription'
          }

          $nav.find('a').each(function() {
            const $this = $(this);
            let path = $this.attr('href');
            if (path === destination || path === alias) {
              $this
                .parent('li')
                .addClass('menu-item--active-destination')
                .parents('li')
                .addClass('menu-item--active-trail');
            }
          });
        }
      }
    },
  };
})(Drupal, jQuery, once);
